export default __webpack_public_path__ + "static/media/happy-puppy-68.76456c10cb4e2b138bf39c466d68d568.jpg";